import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../../contexts/AuthContext';
import MainLayout from '../../common/MainLayout';

function AdminMFA() {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { verifyMFA } = useAuth();

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');

    try {
      await verifyMFA(code);
      navigate('/admin');
    } catch (err) {
      setError('Invalid verification code');
    }
  };

  return (
    <MainLayout>
      <div className="max-w-md mx-auto">
        <h2 className="text-2xl font-bold mb-6 text-center">Two-Factor Authentication</h2>

        {error && <div className="bg-red-900 text-red-200 p-3 rounded mb-4">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="verification-code" className="block text-white mb-2">
              Verification Code
            </label>
            <input
              id="verification-code"
              type="text"
              value={code}
              onChange={e => setCode(e.target.value)}
              className="w-full p-2 rounded bg-hdlcc-gray text-white border border-hdlcc-gray focus:border-hdlcc-lightBlue focus:outline-none"
              required
              maxLength={4}
              placeholder="Enter code: 1234"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-hdlcc-lightBlue text-white py-2 px-4 rounded hover:bg-hdlcc-blue"
          >
            Verify
          </button>
        </form>
      </div>
    </MainLayout>
  );
}

export default AdminMFA;
